import { render, staticRenderFns } from "./AddressChangeNotice.vue?vue&type=template&id=79f92795"
import script from "./AddressChangeNotice.vue?vue&type=script&lang=ts"
export * from "./AddressChangeNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports